import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#031f30" }, [
      _createElementVNode("path", { d: "M6.75 0A6.26 6.26 0 0 0 .5 6.25a6.26 6.26 0 0 0 6.25 6.25A6.26 6.26 0 0 0 13 6.25 6.26 6.26 0 0 0 6.75 0m0 11.25c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5-2.244 5-5 5M12.819 11.431a.622.622 0 1 0-.882.882l2.5 2.5a.6.6 0 0 0 .438.187.622.622 0 0 0 .444-1.062z" })
    ], -1)
  ]))]))
}
export default { render: render }